<template>
    <div class="sidenav-base">
        <v-navigation-drawer
                fixed
                app
                mobile-breakpoint="960"
                v-model="drawer"
                class="navigation-drawer"
                max-height="calc(100% - 64px)"
                v-if="loggedIn"
        >

            <v-card flat v-if="false" style="border-radius: 0">
                <v-list class="responsive-drawer-title">
                    <img class="logo-responsive" src="../assets/logo-exportafacil.png"/>
                    <v-list-item>
                        <v-list-item-title v-text="title" style="color:white"
                                           class="font-weight-medium"></v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>

            <v-card flat style="border-radius: 0; text-align: center" height="120px"
                    >
                <img style="height: 96px; margin-top: 10px" src="../assets/logo-exportafacil.png" alt="Logo"/>
            </v-card>

            <v-divider></v-divider>
            <v-list nav>
                <template>
                    <v-list-item
                            :to="!option.disabled ? option.link : ''"
                            :key="option.title"
                            v-for="option in linksPermission"
                    >
                        <v-list-item-title :id="option.id" v-text="option.title" class="font-weight-medium"></v-list-item-title>
                    </v-list-item>
                </template>
                <v-divider></v-divider>

                <v-list-group v-model="mostrarConfiguracion" v-if="puedeConfigurar">
                    <template v-slot:activator>
                        <v-list-item-title class="font-weight-medium" v-text="'Configuración'"></v-list-item-title>
                    </template>
                    <v-list-item
                            class="pl-6"
                            :to="option.link"
                            :key="option.title"
                            v-for="option in filteredConfiguracionDrawerOptions"
                    >
                        <v-list-item-title v-text="option.title" class="font-weight-medium"></v-list-item-title>
                    </v-list-item>
                </v-list-group>
            </v-list>
            <template v-slot:append>
                <v-bottom-navigation
                        style="justify-content: left"
                >
                    <v-btn icon color="primary" @click="$vuetify.theme.dark=!$vuetify.theme.dark">
                        <v-icon medium>{{isDark ? 'brightness_medium': 'brightness_high'}}</v-icon>
                    </v-btn>
                </v-bottom-navigation>
            </template>
        </v-navigation-drawer>
        <v-app-bar class="main-toolbar white--text primary" app>
            <v-app-bar-nav-icon
                v-if="loggedIn"
                @click.stop="drawer = !drawer" class="white--text"></v-app-bar-nav-icon>
            <v-toolbar-title
                    class="app-toolbar-title"
                    :class="{'subheading': $vuetify.breakpoint.smAndDown}"
            >
                    <router-link to="/" class="white--text" style="text-decoration: none">
                    <img style="height: 48px" class="pt-2" src="../assets/logo-exportafacil.png" alt="Logo"/>
                </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
                flat
                solo-inverted
                hide-details
                append-icon="search"
                v-model="search"
                @keyup.enter.native="onSearch"
                label="Buscar"
                style="max-width: 60vw;"
                v-if="mostrarBusqueda"
            ></v-text-field>
            <v-btn icon v-if="false" @click="mostrarAyuda = true" class="white--text">
                <v-icon medium>help</v-icon>
            </v-btn>
            <v-menu bottom left id="accountButton">
                <template v-slot:activator="{ on }" >
                    <v-btn class="white--text" text v-on="on">
                        <v-icon medium>account_circle</v-icon>
                        {{username}}
                    </v-btn>
                </template>
                <v-list id="accountMenu" v-if="loggedIn">
                    <v-list-item v-if="deferredPrompt" @click="deferredPrompt.prompt">
                        <v-list-item-title>Instalar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logoutClick()">
                        <v-list-item-title id="logoutBtn">Cerrar sesión</v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-list v-else>
                    <v-list-item @click="$router.push({name: 'login'})">
                        <v-list-item-title>Ingresar</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-main>
            <router-view></router-view>
        </v-main>
        <ContextHelp v-model="mostrarAyuda"></ContextHelp>
        <InfoSnackbar :snackbar="snackbar"></InfoSnackbar>
    </div>
</template>

<script>
import InfoSnackbar from '../components/utils/InfoSnackbar';
import snackbarMixin from '../mixins/snackbarMixin';
import { mapActions, mapGetters, mapState } from 'vuex';
import { LOGOUT } from '../store/store-actions';
import permisosMixin from '../mixins/permisosMixin';
import ContextHelp from '../components/context-help/ContextHelp';
import {
  ROL_ADMIN,
  ROL_DINACOPA_ADMISION,
  ROL_DINACOPA_LOGISTICA,
  ROL_DINACOPA_OPERACIONES,
  ROL_VUE,
  DEFAULT_ERROR_MESSAGE
} from '@/constants';

export default {
        name: 'SidenavBase',
        components: {ContextHelp, InfoSnackbar},
        mixins: [permisosMixin, snackbarMixin],
        data() {
            return {
                title: 'Exporta Fácil',
                linksPermission: [],
                // Para tener un orden
                drawerOptionsForConfiguration: [
                ],
                // Menu principal
                drawerOptionsForMenu: [
                  {title: 'Despachos', link: '/despachar', permiso: () => this.usuario && this.usuario.usuario && this.usuario.usuario.rol.nombre === ROL_DINACOPA_LOGISTICA},
                  {title: 'Enviar Formularios a DNA', link: '/enviar-tees', permiso: () => this.usuario && this.usuario.usuario && this.usuario.usuario.rol.nombre === ROL_DINACOPA_OPERACIONES},
                  {title: 'Generar formulario', link: '/generar-formulario', permiso: () => this.usuario && this.usuario.exportador},
                  {title: 'Formularios', link: '/formulario', permiso: () => this.usuario && this.usuario.exportador},
                  {title: 'Formularios', link: '/formulario-admin', permiso: () => this.usuario && this.usuario.usuario && [ROL_DINACOPA_OPERACIONES, ROL_DINACOPA_ADMISION, ROL_VUE, ROL_DINACOPA_LOGISTICA].includes(this.usuario.usuario.rol.nombre)},
                  {title: 'Personas', link: '/persona', permiso: () => this.usuario && this.usuario.exportador},
                    {title: 'Importadores', link: '/importador', permiso: () => this.usuario && this.usuario.exportador},
                  {title: 'Usuarios', link: '/usuarios', permiso: () => this.usuario && this.usuario.usuario && this.usuario.usuario.rol.nombre === ROL_ADMIN},
                ],
                //Otros sitios sin permisos
                drawerOthers: [
                    // {title: 'Cuenta', link: azonSocial'/micuenta', id: 'micuenta'}
                ],
                drawer: !this.$vuetify.breakpoint.mobile,
                mostrarConfiguracion: false,
                mostrarAyuda: false,
                deferredPrompt: null,
                search: '',
            };
        },
        methods: {
            ...mapActions([LOGOUT]),
            async logoutClick() {
                try {
                    await this.$http.post(`${process.env.VUE_APP_ROOT_API}vue/logout`, this.authData);
                } catch (err) {
                    this.snackbar.message = DEFAULT_ERROR_MESSAGE;
                    this.addSnack({
                        message: this.snackbar.message,
                        type: 'error',
                    });
                }
                this[LOGOUT]();
                this.$router.push('/login').catch(err => {});
            },
            cargarLinks() {
                this.linksPermission = this.drawerOptionsForConfiguration.filter(d => d.permiso && d.permiso()).concat(this.drawerOptionsForMenu.filter(d => d.permiso && d.permiso())).concat(this.drawerOthers);
            },
            getMenuConPermiso() {
              let menuPermiso = this.drawerOptionsForMenu.concat(this.drawerOptionsForConfiguration).find(m => m.permiso());
              if (menuPermiso) {
                this.$router.replace(menuPermiso.link);
              }
            },
            ...mapActions('auth', ['getCurrentUser', ]),
        },
        computed: {
            puedeConfigurar() {
                return this.drawerOptionsForConfiguration.some(c => c.permiso);
            },
            filteredConfiguracionDrawerOptions() {
                return this.drawerOptionsForConfiguration.filter(o => o.permiso);
            },
            isDark(){
                return this.$vuetify.theme.dark;
            },
            mostrarBusqueda() {
               return this.$route.path.match(/\/public\/?\w+/)
            },
            username() {
              return this.usuario ? (
                  this.usuario.usuario ?
                      this.usuario.usuario.username :
                      this.usuario.exportador.razonSocial
              ) : '';
            },
            ...mapGetters(['loggedIn', ]),
            ...mapState('auth', ['usuario',]),
        },
        created() {
            this.getCurrentUser();
        },
        mounted() {
          this.cargarLinks();
          this.drawerOptionsForConfiguration.sort((a, b) => a.title > b.title ? 1 : -1);
          if (this.$route.path === '/') {
            this.$nextTick().then(
                () => {
                  this.getMenuConPermiso();
                }
            );
          }
          document.addEventListener('beforeinstallprompt', (e) => {
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e;
            this.deferredPrompt.userChoice
                .then(() => {
                  this.deferredPrompt = null;
                });
          });
        },
        watch: {
          $route: {
            handler(toRoute, fromRoute) {
              if (toRoute.path.length === 1) {
                  this.getMenuConPermiso();
              }
          }
          },
          '$vuetify.theme.dark': function () {
            localStorage.setItem('themeSelect', this.$vuetify.theme.dark ? 'dark' : 'light');
          },
          usuario: {
            deep: true,
            handler() {
              this.cargarLinks();
            },
          },
        },

    };
</script>

<style scoped>

    .main-toolbar {
        /*background: #303945 !important;*/
        /*background-image: url("../assets/banner.png");*/
        /*background-repeat: no-repeat;*/
        /*background-position: center center;*/
        /*background-size: auto 360px;*/
    }

    .responsive-drawer-title {
        /*background: #303945 !important;*/
        /*color: white;*/
    }

    .logo-responsive {
        width: auto;
        height: 48px;
    }
</style>
